import { Injectable } from "@angular/core";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BrokerStatus } from "@partner/shared/SharedConstants";
import { AutosaveFormDetailsParams, FormDetailsComponentData } from "../../../form-details.model";
import { FormDetailsActionsService } from "../../../services/actions/form-details-actions.service";
import { AutosaveFormDetailsFacade } from "../../../services/autosave/autosave-form-details.facade";

@UntilDestroy()
@Injectable()
export class SharedDetailsService {
  constructor(
    private readonly autosaveFormDetailsFacade: AutosaveFormDetailsFacade,
    private readonly formDetailsActions: FormDetailsActionsService,
  ) { }

  initAutosaveData(initialData: FormDetailsComponentData): void {
    const params: AutosaveFormDetailsParams = {
      brokerId: initialData?.application?.brokerId ?? (initialData.currentAccount?.brokerId as number),
      accountId: initialData?.application?.accountId,
      applicationId: initialData?.application?.id,
    };
    this.autosaveFormDetailsFacade.initData(params, initialData?.formData)
  }

  initAutosaveActions(): void {
    this.autosaveFormDetailsFacade.isAutosaveInProgress$.pipe(untilDestroyed(this)).subscribe();
  }

  expandAllSectionsIfIncomplete(brokerStatus: BrokerStatus): void {
    if (brokerStatus !== BrokerStatus.SUBMISSION_INCOMPLETE) {
      return;
    }
    this.formDetailsActions.expandAllSections();
  }
}
